// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Tojwg","headerWrapper":"style_headerWrapper__3k-7m","title":"style_title__t+chq","img":"style_img__B6mup"};